var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:("px-" + _vm.paddingPx + " py-" + _vm.paddingPy + " elevation-" + _vm.elevationHeight + " " + (_vm.hardShadow ? 'hard' : ''))},[_vm._t("default",function(){return [_vm._v("Content")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }